import React, { Component } from 'react';
import './home-page.css'
import './slick.css'
import Slider from 'react-slick'
import NuxeoClient from '../../clients/NuxeoClient';

class HomePage extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            imageUrls:[],
            fetched:false
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    async componentDidMount(){
        await this._loadCarousels()
    }
    async _loadCarousels(){
        let imageUrls=[]
        let self=this
        await NuxeoClient
            .instance()
            .fetchCarousel()
            .then((response) => {
                response.entries.forEach((item)=>{
                    imageUrls.push(item.properties['thumb:thumbnail'].data)
                })
                self.setState({imageUrls:imageUrls,fetched:true})
            });
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    render(){
        var settings = {
            infinite: true,
            slidesToShow: 7,
            dots: false,
            slidesToScroll: 1,
            //lazyLoad: 'ondemand',
            slide: '.slide',
            autoplay: true,
            speed: 400,
            centerMode: true,
            centerPadding: '0px',
            waitForAnimate: true,
            useCSS:true,
            autoplaySpeed:5000,
            //cssEase: 'linear',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    //centerMode: true,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    //centerMode: true,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    //centerMode: true,
                  }
                }
              ]
          };
        var items=[]
        if(this.state.fetched===true){
            items = this.state.imageUrls.map(function(item,key){
                return (
                <div key={key} class="asset_placeholder">
                    <img key={key} class="asset_img" src={item} alt=""
                    />
                </div>
                );
            });
        }

        return(
            <div class="body">
                <div class="container">
                    <i class="material-icons icon_slick_nav icon_slick_nav-lt large" onClick={this.previous}>chevron_left</i>
                    <i class="material-icons icon_slick_nav icon_slick_nav-rt large" onClick={this.next}>chevron_right</i>
                    {
                    this.state.fetched?
                        <div class="carousel1 " >
                            <div id="carousel1" class="slick-initialized slick-slider">
                            <Slider ref={c => (this.slider = c)} {...settings} arrows={false}>
                                {items}
                            </Slider>
                            </div>
                        </div>
                    :null
                    }   
                </div>
            </div>
        )
    }
}

export default HomePage;